import axios from '../axios/axios-api'

async function validarCliente (code) {
  const clientIsValid = await axios.post(`/api/clientes/${code}/validar`)
  return clientIsValid.data
}

export default validarCliente
